import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "./highchartsInit";

const AnalyticsChart = ({ options, height = 260, className = "", slotClassName = "" }) => (
  <div className={`analytics-chart-slot ${slotClassName} ${className}`.trim()} style={{ minHeight: height }}>
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      immutable={false}
      containerProps={{ className: "analytics-chart-container", style: { height: `${height}px`, width: "100%", background: "transparent" } }}
    />
  </div>
);

export default AnalyticsChart;
